import { init, add, getDeviceId, identify, Identify, track } from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

/**
 * Initialize Amplitude with the provided API_KEY
 * @param {string} apiKey - Amplitude API_KEY
 */
export const initializeAmplitude = (apiKey) => {
  try {
    if (apiKey) {
      const sessionReplayTracking = sessionReplayPlugin({sampleRate: 1});
      add(sessionReplayTracking);
      init(apiKey, {
        autocapture: {
          marketingAttribution: true,
          pageViews: true,
          sessions: true, // Disable session tracking if desired
          formInteractions: true, // Disable form interactions
          fileDownloads: true, // Disable file downloads
          elementInteractions: true, // Captures clicks, form submissions, etc.
        },
      }).promise.then(() => {
        const deviceId = getDeviceId();
        console.log('Amplitude initialized. Device Id:', deviceId);
      });
    } else {
      console.log('Amplitude apiKey not found. Skipping initialization.')
    }
  } catch (error) {
    console.warn('Failed to initialize Amplitude:', error)
  }
}

/**
 * Link Amplitude customer session with customer information
 * @param {Object} user - User object containing user details
 */
export const linkAmplitudeSessionWithUserId = (user) => {
  try {
    const deviceId = getDeviceId();
    if (user.userId && deviceId) {
      const identifyObj = new Identify();
      identifyObj.set('cognito_user_id', user.userId);
      identify(identifyObj, { device_id: deviceId, user_id: user.userId });
      console.log('Initialized Amplitude session ', deviceId);
    } else {
      console.log('Amplitude is not initialized. Skipping session initialization.')
    }
  } catch (error) {
    console.warn('Failed to link Amplitude session:', error)
  }
}

/**
 * Send Tracking to Amplitude
 * @param {string} userId - User Id
 * @param {string} eventType - Event Type
 * @param {Object} eventProps - Event Props
 * @param {Object} userProps - User Props
 */
export const sendAmplitudeEvent = (userId, eventType, eventProps, userProps) => {
  track({
    event_type: eventType,
    user_id: userId,
    event_properties: eventProps,
    user_properties: userProps,
  });
}